import makeApiCall from "./axiosIndex";
const sitebreakdownMasterApis = {
  siteStructureBulkUploadValidate: (data: any): Promise<any> => {
    return makeApiCall({
      url: "/buyer/validateBulkSiteStructureUnitCreation",
      method: "post",
      data,
    });
  },

  fetchSiteBreakDownWithPagination: (params: any): Promise<any> => {
    return makeApiCall({
      url: "/buyer/fetchSiteStructuresWithPagination",
      method: "get",
      params,
    });
  },
  fetchSiteBreakDownDropDown: (): Promise<any> => {
    return makeApiCall({
      url: "/buyer/fetchSiteStructureDropDown",
      method: "get",
    });
  },

  fetchUnitsBySiteId: (params: {
    siteId: number | string;
    unitId?: number | string;
    floorNo?: string;
  }): Promise<any> => {
    return makeApiCall({
      url: "/buyer/fetchSiteStructureUnitsBySiteId",
      method: "get",
      params,
    });
  },

  fetchFloorNumbersByUnitId: (params: {
    siteId: number | string;
    unitId: number | string;
  }): Promise<any> => {
    return makeApiCall({
      url: "/buyer/fetchFloorNumbersByUnitId",
      method: "get",
      params,
    });
  },

  fetchLocationsBySiteId: (params: {
    siteId: number | string;
  }): Promise<any> => {
    return makeApiCall({
      url: "/buyer/fetchLocationsBySiteId",
      method: "get",
      params,
    });
  },

  fetchSubUnitsByUnitId: (params: {
    siteId: number | string;
    unitId: number | string;
    floorNo?: string;
  }): Promise<any> => {
    return makeApiCall({
      url: "/buyer/fetchSiteStructureSubUnitsByUnitId",
      method: "get",
      params,
    });
  },

  fetchTypeDropDown: (): Promise<any> => {
    return makeApiCall({
      url: "/buyer/fetchProjectTypesDropDown",
      method: "get",
    });
  },

  fetchSiteBreakDownById: (id: number): Promise<any> => {
    return makeApiCall({
      url: `/buyer/fetchSiteStructureById`,
      method: "get",
      params: { id },
    });
  },

  updateSiteBreakDownById: (id: number, data: any): Promise<any> => {
    return makeApiCall({
      url: `/buyer/updateSiteStructureById`,
      method: "put",
      params: { id },
      data,
    });
  },

  createSiteBreakDown: (data: any): Promise<any> => {
    return makeApiCall({
      url: `/buyer/createNewSiteStructure`,
      method: "post",
      data,
    });
  },

  // Site Structure Actions
  deleteSiteStructureById: (id: number): Promise<any> => {
    return makeApiCall({
      url: "/buyer/deleteSiteStructureById",
      method: "delete",
      params: { id },
    });
  },

  activateSiteStructureById: (id: number): Promise<any> => {
    return makeApiCall({
      url: "/buyer/activateSiteStructureById",
      method: "patch",
      params: { id },
    });
  },

  inactivateSiteStructureById: (id: number): Promise<any> => {
    return makeApiCall({
      url: "/buyer/inactivateSiteStructureById",
      method: "patch",
      params: { id },
    });
  },

  // Units Bulk Actions
  activateUnitsByIds: (data: { ids: number[] }): Promise<any> => {
    const { ids } = data;
    return makeApiCall({
      url: "/buyer/activateUnitsByIds",
      method: "patch",
      data: { unitIds: ids },
    });
  },

  inactivateUnitsByIds: (data: { ids: number[] }): Promise<any> => {
    const { ids } = data;
    return makeApiCall({
      url: "/buyer/inactivateUnitsByIds",
      method: "patch",
      data: { unitIds: ids },
    });
  },

  holdUnitsByIds: (data: { ids: number[] }): Promise<any> => {
    const { ids } = data;
    return makeApiCall({
      url: "/buyer/holdUnitsByIds",
      method: "patch",
      data: { unitIds: ids },
    });
  },

  deleteUnitsByIds: (data: { ids: number[] }): Promise<any> => {
    const { ids } = data;
    return makeApiCall({
      url: "/buyer/deleteUnitsByIds",
      method: "delete",
      data: { unitIds: ids },
    });
  },

  // SubUnits Bulk Actions
  activateSubUnitsByIds: (data: { ids: number[] }): Promise<any> => {
    const { ids } = data;
    return makeApiCall({
      url: "/buyer/activateSubUnitsByIds",
      method: "patch",
      data: { subUnitIds: ids },
    });
  },

  inactivateSubUnitsByIds: (data: { ids: number[] }): Promise<any> => {
    const { ids } = data;
    return makeApiCall({
      url: "/buyer/inactivateSubUnitsByIds",
      method: "patch",
      data: { subUnitIds: ids },
    });
  },

  deleteSubUnitsByIds: (data: { ids: number[] }): Promise<any> => {
    const { ids } = data;
    return makeApiCall({
      url: "/buyer/deleteSubUnitsByIds",
      method: "delete",
      data: { subUnitIds: ids },
    });
  },

  workUom: (params: any): Promise<any> =>
    makeApiCall({
      url: `/masters/workUomsList`,
      method: "get",
      params,
    }),
};

export default sitebreakdownMasterApis;
